import styled from "@emotion/styled";
import { PureComponent } from "react";

import { Button, ButtonKind } from "@livechat/design-system";

import { IButtonData } from "services/custom-section";

interface IProps {
  label: string;
  kind?: ButtonKind;
  customId?: string;
  openApp?: boolean;
  onClick?: (buttonData: IButtonData) => void;
}

const StyledButton = styled(Button)`
  margin: 0 4px 4px 0;
`;

export class CustomButton extends PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleClick = () => {
    if (!this.props.onClick) {
      return;
    }

    const { label, openApp, customId: id } = this.props;
    // @ts-expect-error TS(2322)
    this.props.onClick({ id, label, openApp });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return (
      <StyledButton onClick={this.handleClick} kind={this.props.kind}>
        <span>{this.props.label}</span>
      </StyledButton>
    );
  }
}
